import React, { Component, Fragment } from 'react';
import {
    Nav,
    MetaTags,
    OrderSummary,
    Loading,
    ContinueButton,
    CadenceModal,
    CadenceAlert
} from '../Common';
import PhoneVerification from '../Common/Connected/PhoneVerification';
import moment from 'moment';
import { getUser, getCadenceMonths } from '../../actions';
import * as Sentry from '@sentry/browser';
import { connect } from 'react-redux';
import ReactGA from 'react-ga';
import * as images from '../../assets';
import { Auth } from 'aws-amplify';
import Confetti from 'react-confetti';
import { CheckoutBody as Body } from '../../Style';
import { featureFlags, experiments } from '../../config';
import { Logger } from '../../helpers/Logger';
const logger = new Logger();
const prod = (process.env.REACT_APP_SUPPLY_DROP_ENVIRONMENT === 'production');

class OrderComplete extends Component {
    constructor(props) {
        super(props);
        const checkout_summary = featureFlags.checkout_summary_override

        this.state = {
            checkout_summary
        };

        this.next = this.next.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.setToVerified = this.setToVerified.bind(this);
        this.setToLimitExceeded = this.setToLimitExceeded.bind(this);
        this.setStepOneBody = this.setStepOneBody.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.setExperiments = this.setExperiments.bind(this);
    }

    componentDidMount() {
        try {
            window.sd_optimize.registerListener(this.setExperiments)
            window.dataLayer.push({ 'event': 'optimize.activate' });
        } catch (error) {
            logger.error(error)
        }

        if (this.props.location && this.props.location.state)
            this.setSignUpData(this.props.location.state.signUpData);

        this.props.getUser();

        this.handleResize();

        Auth.currentAuthenticatedUser().then(user => {
            if (user.attributes && user.attributes.phone_number_verified) {
                this.setState({ verified: true })
            }
        }).catch(err => {
            Sentry.captureEvent(new Error('Auth.currentAuthenticatedUser errror'))
            Sentry.captureException(err)
        })
    }

    componentDidUpdate() {
        const { user } = this.props;
        if (user && !this.state.user) {
            this.setState({ user, customer: user.customer });
            try {
                const { cadenceWeeks } = user.manifest;
                const { cadenceMonths } = getCadenceMonths(cadenceWeeks);
                this.setState({ cadenceMonths });
            } catch (err) {
                console.error(err);
                this.setState({ cadenceMonths: { title: 'Monthly', int: 1 } })
                Sentry.captureException(err);
            }
        }
    }

    componentWillMount() {
        window.addEventListener('resize', this.handleResize, false);
        window.addEventListener('keydown', this.handleKeydown, false);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize, false);
        window.removeEventListener('keydown', this.handleKeydown, false);
        try {
            window.sd_optimize.unregisterListener()
        } catch (err) {
            logger.error(err)
        }
    }

    setExperiments(activeExperiments) {
        try {
            const mui_checkout = activeExperiments[experiments.mui_checkout];
            if (mui_checkout && parseInt(mui_checkout)) {
                this.setState({ mui_checkout, checkout_summary: mui_checkout })
            }
        } catch (err) {
            logger.error(err)
        }
    }

    handleKeydown(e) {
        const { showCadenceModal } = this.state;

        if (e.keyCode && e.keyCode === 27) {
            if (showCadenceModal)
                this.setState({ showCadenceModal: false })
        }
    }

    setSignUpData(signUpData) {
        try {
            this.setState({ signUpData })
            this.setStateForKeyValue(signUpData);
            const { completedOrder } = signUpData;
            this.setTax(completedOrder);
        } catch (err) {
            console.error(err);
        }
    }

    next() {
        const { verified } = this.state;
        if (prod)
            ReactGA.event({ category: 'DashboardView', action: 'After-Interview' })

        this.props.history.push('/dashboard/orders', { dashboardData: { verified } });
    }

    setTax(completedOrder) {
        try {
            const { order, expectedDeliveryDate } = completedOrder;
            const { taxes } = order;
            let taxTotal = 0;
            taxes.forEach(tax => {
                taxTotal += tax.amountCents;
            })
            this.setState({ expectedDeliveryDate, taxTotal })
        } catch (err) {
            this.setState({ orderError: err })
            console.error(err);
            Sentry.captureException(err);
        }
    }

    setStateForKeyValue(data) {
        try {
            Object.entries(data).forEach(entry => {
                const key = entry[0], value = entry[1];
                if (value !== undefined) {
                    this.setState({ [key]: value })
                }
            })
        } catch (err) {
            console.error(err);
        }
    }

    handleResize(e) {
        const { isMobile } = this.state;
        if (window.innerWidth < 992 && !isMobile) {
            this.setState({ isMobile: true })
        }
        if (window.innerWidth >= 991 && isMobile) {
            this.setState({ isMobile: false })
        }
    }

    setToVerified() {
        this.setState({ verified: true })
    }

    setToLimitExceeded() {
        this.setState({ limitExceeded: true })
    }

    renderDYK() {
        const { checkout_summary } = this.state;
        const points = [
            (
                <Fragment>
                    <b>You can text us at 30389</b> with messages like “When is my next delivery?” or “I need less toilet paper” and we’ll update your subscription.
                </Fragment>
            ),
            (
                <Fragment>
                    <b>Running low?</b> Text us so we can get you an emergency order ahead of your next delivery. No need to run out or run to the store; just text us!
                </Fragment>
            ),
            (
                <Fragment>
                    <b>We predict how much you’ll need every month.</b> If you would like to make adjustments, you can easily change your product selection and quantity.
                </Fragment>
            )
        ]

        let i = 0;
        const rows = points.map(point => {
            const row = (
                <div key={point.props.children[1]} className="did-you-know-row">
                    <img alt="Did you know?" src={images[`dyk_${i}`]} className="did-you-know-img" />
                    <div className="did-you-know-copy">
                        {point}
                    </div>
                </div>
            )
            i++
            return row;
        })


        return (
            <div id="oc-did-you-know" className={checkout_summary ? "checkout-summary-padding" : ""}>
                <div id="did-you-know-header">Did you know?</div>
                {rows}
            </div>
        )
    }

    renderDesktopOrderSummary() {
        const {
            isMobile,
            manifestBundles,
            taxTotal,
            coupon,
            employer,
            newCoupon,
            sdCredit,
            isEmployeePerk,
            refCust,
            checkout_summary
        } = this.state;
        if (!isMobile) {
            return (
                <OrderSummary
                    manifestBundles={manifestBundles}
                    tax={taxTotal}
                    coupon={coupon}
                    newCoupon={newCoupon}
                    sdCredit={sdCredit}
                    employer={employer}
                    isEmployeePerk={isEmployeePerk}
                    didYouKnow={this.renderDYK()}
                    showReferral={refCust ? true : false}
                    checkout_summary={checkout_summary}
                    viewModal={() => this.setState({  showOrderSummaryModal: true})}
                />
            )
        }
    }

    renderMobileOrderSummary() {
        const {
            isMobile,
            manifestBundles,
            taxTotal,
            coupon,
            isEmployeePerk,
            employer,
            newCoupon,
            sdCredit,
            checkout_summary
        } = this.state;
        if (isMobile) {
            return (
                <OrderSummary
                    manifestBundles={manifestBundles}
                    orderComplete={true}
                    tax={taxTotal}
                    employer={employer}
                    coupon={coupon}
                    isEmployeePerk={isEmployeePerk}
                    newCoupon={newCoupon}
                    sdCredit={sdCredit}
                    checkout_summary={checkout_summary}
                    didYouKnow={this.renderDYK()}
                />
            )
        }
    }

    renderOrderSummaryModal() {
        const {
            isMobile,
            manifestBundles,
            coupon,
            isEmployeePerk,
            employer,
            tax,
            newCoupon,
            sdCredit,
            refCust,
            checkout_summary,
            showOrderSummaryModal
        } = this.state;
        if (showOrderSummaryModal) {
            return (
                <OrderSummary
                    checkout_summary={checkout_summary}
                    manifestBundles={manifestBundles}
                    coupon={coupon}
                    newCoupon={newCoupon}
                    sdCredit={sdCredit}
                    isEmployeePerk={isEmployeePerk}
                    employer={employer}
                    tax={tax}
                    showValueProps={!isMobile}
                    showReferral={refCust ? true : false}
                    isModal={true}
                    close={() => this.setState({ showOrderSummaryModal: false })}
                />
            )
        }
    }

    renderHeader() {
        const { expectedDeliveryDate } = this.state;
        if (expectedDeliveryDate) {
            return (
                <div className="order-complete-header">
                    Success! Your first delivery with your Essentials is arriving on {moment(expectedDeliveryDate).format("MMMM Do")}
                </div>
            )
        }
    }

    setStepOneBody() {
        const { verified, customer, limitExceeded } = this.state;
        let copy, button;
        if (verified) {
            copy = "Thanks, you’ve successfully verified your phone number!";
            button = <div className="text-center"><ContinueButton text="Go to your dashboard" next={this.next} fixed={true} noMargin={true} /></div>
        } else if (limitExceeded) {
            copy = "Limit reached for phone verification. Please try again another time."
            button = <div className="text-center"><ContinueButton text="Go to your dashboard" next={this.next} fixed={true} noMargin={true} /></div>
        } else {
            copy = <span>Thanks for signing up. You should have received a text from us <b>(30389)</b> with a numeric code to verify your account.</span>
            button = <PhoneVerification limitExceeded={this.setToLimitExceeded} email={customer.email} phone={customer.phone} setToVerified={this.setToVerified} />
        }
        return { copy, button }
    }

    renderCTA() {
        const { customer } = this.state;
        if (customer) {
            const { copy, button } = this.setStepOneBody()
            return (
                <Fragment>
                    <div className="whats-next-step">
                        <div className="whats-next-section-container">
                            <div className="whats-next-number-circle">
                                <div className="whats-next-number">1</div>
                            </div>
                        </div>
                        <div className="whats-next-section-container">
                            <div className="whats-next-copy">
                                {copy}
                            </div>
                        </div>
                    </div>
                    {button}
                </Fragment>
            )
        }
    }

    renderWhatsNextBullets() {
        const { expectedDeliveryDate, cadenceMonths } = this.state;

        var whatsNextDelivery = "You will receive your Supply Drop each month.";
        if (cadenceMonths.int > 1) {
            whatsNextDelivery = `Starting with your 2nd delivery, you will receive your Supply Drop ${cadenceMonths.title} so each delivery will have ${cadenceMonths.int} months worth of supplies.`
        }

        return (
            <Fragment>
                {this.renderCTA()}
                <div className="whats-next-step">
                    <div className="whats-next-section-container">
                        <div className="whats-next-number-circle">
                            <div className="whats-next-number">2</div>
                        </div>
                    </div>
                    <div className="whats-next-section-container">
                        <div className="whats-next-copy">
                            You'll receive your first Supply Drop on {moment(expectedDeliveryDate).format('MMMM Do')}.
                        </div>
                    </div>
                </div>
                <div className="whats-next-step">
                    <div className="whats-next-section-container">
                        <div className="whats-next-number-circle">
                            <div className="whats-next-number">3</div>
                        </div>
                    </div>
                    <div className="whats-next-section-container">
                        <div className="whats-next-copy">
                            {whatsNextDelivery}
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }

    renderWhatsNext() {
        const { expectedDeliveryDate, cadenceMonths } = this.state;
        if (cadenceMonths && expectedDeliveryDate) {
            return (
                <Fragment>
                    <div className="order-complete-header">What's next:</div>
                    {this.renderWhatsNextBullets()}
                </Fragment>
            )
        } else {
            return (
                <div id="order-complete-loading-container">
                    <Loading />
                </div>
            )
        }
    }

    renderMain() {
        return (
            <Fragment>
                <div className="text-center">
                    <img alt="Happy house" id="oc-img" src={images.oc_house} />
                </div>
                {this.renderHeader()}
                {this.renderCadenceAlert()}
                {this.renderWhatsNext()}
            </Fragment>
        )
    }

    renderConfetti() {
        return (
            <Confetti
                height={400}
                recycle={false}
            />
        )
    }

    renderCadenceAlert() {
        const { cadenceMonths } = this.state;
        if (cadenceMonths)
            return <CadenceAlert months={cadenceMonths.int} title={cadenceMonths.title} onclick={() => this.setState({ showCadenceModal: true })} />
    }

    renderCadenceModal() {
        const { cadenceMonths, showCadenceModal } = this.state;
        if (showCadenceModal && cadenceMonths) {
            return (
                <CadenceModal cadenceMonths={cadenceMonths.int} close={() => this.setState({ showCadenceModal: false })} />
            )
        }
    }

    render() {
        return (
            <Fragment>
                <MetaTags title="Supply Drop - Thank You!" />
                <Nav pathname="/dashboard/orders" />
                {this.renderCadenceModal()}
                {this.renderOrderSummaryModal()}
                <div className="has-fixed-continue">
                    <Body>
                        <div className="checkout-main">
                            <div className="checkout-container">
                                {this.renderConfetti()}
                                {this.renderMain()}
                            </div>
                        </div>
                        {this.renderDesktopOrderSummary()}
                    </Body>
                    {this.renderMobileOrderSummary()}
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    const { user, getUserError } = state.user;
    return { user, getUserError }
}

export default connect(mapStateToProps, {
    getUser
})(OrderComplete);
